/* Link.tsx
   Version: 1.0.0
   Date: 2020-12-10
*/

// eslint-disable-next-line
import * as React from 'react';
import PropTypes from 'prop-types';

export interface LinkProps {
    children?: React.ReactNode,
    className?: string;
    reference: string;
}

const Link: React.FC<LinkProps> = (props): JSX.Element => {

    Link.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        reference: PropTypes.string.isRequired,
    }
    
    
    return(
        <a className="basic-link" href={props.reference}>{props.children}</a>
    );

}

export default Link;
